<script setup lang="ts">

defineProps({
  active: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
<button :class="{
  'py-1 px-2 hover:bg-slate-500 rounded': true,
  'bg-slate-800': active,
  'bg-slate-700': !active
}">
  <slot></slot>
</button>
</template>

<style scoped lang="scss">

</style>